import { UIHeading4, UIText2 } from '@cian/ui-kit';
import * as React from 'react';
import { RosreestrLabel } from '../../RosreestrLabel/RosreestrLabel';
import { CARD_PRICE, CARD_TITLE, ROSREESTR_DATA } from '../constants';
import * as styles from './Content.css';
import { useDeviceCondition } from '../../../../../hooks';

export const Content = () => {
  const containerlassName = useDeviceCondition(styles['row-template'], styles['column-template']);

  return (
    <div className={containerlassName}>
      <div className={styles['card']}>
        <div className={styles['image']} />
        <div className={styles['card-info']}>
          <div className={styles['name']}>
            <UIHeading4 fontWeight="700" color="focused_15">
              {CARD_TITLE}
            </UIHeading4>
          </div>
          <div className={styles['label']}>
            <RosreestrLabel />
          </div>
          <div className={styles['price']}>
            <UIHeading4 fontWeight="700" color="focused_15">
              {CARD_PRICE}
            </UIHeading4>
          </div>
          <div className={styles['skeleton']}>
            {[310, 263].map((width, index) => (
              <div className={styles['dump']} key={index} style={{ width }} />
            ))}
          </div>
        </div>
      </div>
      {ROSREESTR_DATA.map(({ header, elements }) => (
        <div key={header} className={styles['rosreestr-section']}>
          <div className={styles['rosreestr-header']}>
            <UIHeading4 fontWeight="700">{header}</UIHeading4>
          </div>
          <div>
            {elements.map(({ title, value }) => (
              <div key={title} className={styles['rosreestr-data']}>
                <div className={styles['rosreestr-data-title']}>
                  <UIText2 color="gray60_100">{title}</UIText2>
                </div>
                <UIText2>{value}</UIText2>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
